<button *ngIf="routerLink.length === 0"
  [disabled]="disabled"
  (click)="isNew ? handleCreate() : handleUpdate()"
  mat-raised-button color="primary">{{ isNew ? 'Create' : 'Save' }} {{ label }}</button>
<a *ngIf="routerLink.length > 0"
        [disabled]="disabled"
        [routerLink]="routerLink"
        mat-raised-button color="primary">{{ isNew ? 'Create' : 'Save' }} {{ label }}</a>
